
import { supabase } from '@/lib/supabaseClient';
import { useResilientData } from './useResilientData';

const DEFAULT_PROFILE = {
  id: 'default',
  first_name: 'User',
  last_name: '',
  avatar_url: null,
  email: 'user@example.com',
  updated_at: null
};

export const useProfileData = () => {
  return useResilientData({
    queryKey: ["profile"],
    cacheKey: "user_profile",
    fallbackData: DEFAULT_PROFILE,
    queryFn: async () => {
      console.log('[useProfileData] Fetching profile from Supabase');
      
      const { data: { session } } = await supabase.auth.getSession();
      if (!session?.user) {
        throw new Error('No active session');
      }
      
      const { data, error } = await supabase
        .from("profiles")
        .select()
        .eq('id', session.user.id)
        .maybeSingle();
      
      if (error) {
        console.error('[useProfileData] Profile fetch error:', error);
        throw error;
      }
      
      if (!data) {
        console.log('[useProfileData] No profile found, creating default');
        const defaultProfile = {
          id: session.user.id,
          first_name: '',
          last_name: '',
          avatar_url: null,
          email: session.user.email,
          updated_at: null
        };

        // Try to insert the default profile
        const { error: insertError, data: insertedProfile } = await supabase
          .from('profiles')
          .insert(defaultProfile)
          .select()
          .maybeSingle();

        if (insertError) {
          console.error('[useProfileData] Error inserting profile:', insertError);
          return defaultProfile;
        }

        return insertedProfile || defaultProfile;
      }
      
      console.log('[useProfileData] Profile fetched successfully');
      return data;
    },
    retryAttempts: 1, // Reduce retries since we have good fallbacks
    staleTime: 1000 * 60 * 10, // 10 minutes for profile data
  });
};
